import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_PRODUCTBLOCK,
  DELETE_PRODUCTBLOCK,
  UPDATE_PRODUCTBLOCK,
  ADD_NEW_PRODUCTBLOCK,
} from "./actionType";

import {
  getProductBlockSuccess,
  getProductBlockFail,
  deleteProductBlockSuccess,
  deleteProductBlockFail,
  updateProductBlockSuccess,
  updateProductBlockFail,
  addProductBlockSuccess,
  addProductBlockFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveProductBlockApi,
  getProductBlockApi,
  updateProductBlockApi,
  deleteProductBlockApi,
  addNewProductBlockApi
} from "../../helpers/backend_helper";

function* getProductBlock({ payload: productBlock }) {
  try {
    const response = yield call(getProductBlockApi, productBlock);
    yield put(getProductBlockSuccess(GET_PRODUCTBLOCK, response.data));
  } catch (error) {
    yield put(getProductBlockFail(GET_PRODUCTBLOCK, error));
  }
}

function* onUpdateProductBlock({ payload: productBlock }) {
  try {
    if (productBlock.setApprove) {
      const response = yield call(approveProductBlockApi, productBlock);
      yield put(updateProductBlockSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateProductBlockApi, productBlock);
      yield put(updateProductBlockSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateProductBlockFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteProductBlock({ payload: productBlock }) {
  try {
    const response = yield call(deleteProductBlockApi, productBlock);
    yield put(deleteProductBlockSuccess({ productBlock, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteProductBlockFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewProductBlock({ payload: productBlock }) {
  try {
    const response = yield call(addNewProductBlockApi, productBlock);
    yield put(addProductBlockSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addProductBlockFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetProductBlock() {
  yield takeEvery(GET_PRODUCTBLOCK, getProductBlock);
}

export function* watchUpdateProductBlock() {
  yield takeEvery(UPDATE_PRODUCTBLOCK, onUpdateProductBlock);
}

export function* watchDeleteProductBlock() {
  yield takeEvery(DELETE_PRODUCTBLOCK, onDeleteProductBlock);
}

export function* watchAddNewProductBlock() {
  yield takeEvery(ADD_NEW_PRODUCTBLOCK, onAddNewProductBlock);
}

function* productBlockSaga() {
  yield all([
    fork(watchGetProductBlock),
    fork(watchDeleteProductBlock),
    fork(watchUpdateProductBlock),
    fork(watchAddNewProductBlock)
  ]);
}

export default productBlockSaga;
